import { Component, OnInit, HostListener } from '@angular/core';
import { SsrCookieService } from 'ngx-cookie-service-ssr';

/**
 * Cookie consent component.
 */
@Component({
    selector: 'app-cookie-consent',
    templateUrl: './cookie-consent.component.html',
    styleUrls: ['./cookie-consent.component.scss']
})
export class CookieConsentComponent implements OnInit {
  public hasBeenShown = false;
  public showIt = false;
  private hasGotIt = false;

  /**
   * Cookie consent component.
   *
   * @param cookieService the cookie service
   */
  constructor(private cookieService: SsrCookieService) {}

  /**
   * Update the position of the cookie window when scrolling
   */
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (!this.hasGotIt) {
      this.showIt = true;
    }
  }

  ngOnInit() {
    if (this.cookieService.check('hasBeenShown')) {
      this.hasGotIt = true;
    }
  }

  /**
   *  Disables the window when user agree
   */
  iGotIt() {
    this.cookieService.set('hasBeenShown', '1');
    this.showIt = false;
    this.hasGotIt = true;
  }

  /**
   * Closes the modal
   */
  closeModal() {
    this.showIt = false;
    this.hasGotIt = true;
  }
}
